export const jiraRepoPage = (action: string) => `jira-repo-page/${action}`;
export const createJiraIssue = (action: string) =>
  `create-jira-issue/${action}`;
export const jiraIssues = (action: string) => `jira-issues/${action}`;
export const dashboardJiraIssues = (action: string) =>
  `dashboard-jira-issues/${action}`;
export const jiraMigration = (action: string) => `jira-migration/${action}`;
